import { ContentState, EditorState } from "draft-js";
import getCompositeDecorator from "../../../components/CustomRevvEditor/decorator";
import AddTemplateComponentCommand from "../addComponentCommandBase/addTemplateComponentCommand";
import { getContentStateFromRawSectionData } from "../../../utils/components";

class AddTemplateTableComponentCommand extends AddTemplateComponentCommand {
  constructor(componentData, mode) {
    super(componentData, mode);
    this.componentData = componentData;
    this.mode = mode;
  }

  getContentState() {
    const { component } = this.componentData;
    const cell00 = component.data.data[0].data[0].data;
    let contentState = cell00.data;
    if (!(contentState instanceof ContentState)) {
      contentState = getContentStateFromRawSectionData(
        { data: contentState },
        this.mode,
      );
    }
    return contentState;
  }

  addClickedEditorState(contentState) {
    super.activeEditorState = EditorState.createWithContent(
      contentState,
      getCompositeDecorator(),
    );
  }

  addClickedSection() {
    const { component } = this.componentData;
    super.activeComponent = {
      ...component,
    };
  }

  execute() {
    // 1.
    // const contentState = this.getContentState();
    // // 2.
    // this.addClickedSection(contentState);
    // // 3.
    // this.addClickedEditorState(contentState);

    // ----------- add component to template super class ---------
    super.execute();
  }

  undo() {
    super.undo();
  }
}

export default AddTemplateTableComponentCommand;
